/** Bridge: POS checkout completes an appointment sale. */

export type PendingAppointmentCheckout = {
  appointmentId: string;
  /** Primary / first service (compat). */
  productId: string;
  /** PELU-07: all services to prefill in cart. */
  productIds: string[];
};

let pending: PendingAppointmentCheckout | null = null;

export function setPendingAppointmentCheckout(
  appointmentId: string | null,
  productId?: string | null,
  productIds?: string[] | null,
): void {
  if (!appointmentId || !productId) {
    pending = null;
    return;
  }
  const ids =
    productIds && productIds.length > 0
      ? productIds.filter(Boolean)
      : [productId];
  pending = { appointmentId, productId: ids[0] ?? productId, productIds: ids };
}

export function peekPendingAppointmentCheckout(): PendingAppointmentCheckout | null {
  return pending;
}

export function takePendingAppointmentCheckout(): PendingAppointmentCheckout | null {
  const value = pending;
  pending = null;
  return value;
}
